<template>
  <div class="topper">
    <!-- 弹出菜单 -->
    <van-popup v-model="popmenu"
               position="left"
               closeable
               aroud
               close-icon="cross"
               :style="{
        width: '100%',
        height: '100%',
        background: '#fff',
        'border-radius': '0'
      }">
      <!-- 菜单开始 -->
      <div class="menu">
        <!-- 关于我们 -->
        <van-popup v-model="pop_about"
                   position="left"
                   closeable
                   aroud
                   close-icon="cross"
                   :style="{
        width: '100%',
        height: '100%',
        background: '#fff',
        'border-radius': '0'
      }">
          <div class="menu">
            <van-icon name="arrow-left"
                      color="#c8c9cc"
                      size="24"
                      style="position:absolute;left:16px; top:16px;"
                      @click="pop_about=false" />
            <ul>
              <li><a @click="goToPage('about','#jtjj')">集团简介</a></li>
              <li><a @click="goToPage('about','#qywh')">企业文化</a></li>
              <li><a @click="goToPage('about','#shzz')">社会责任</a></li>
              <li><a @click="goToPage('about','#fzlc')">发展历程</a></li>
              <li><a @click="goToPage('about','#ldtd')">领导团队</a></li>
              <li><a @click="goToPage('about','#gpxx')">股票信息</a></li>
            </ul>
          </div>
        </van-popup>
        <!-- 业务布局 -->
        <van-popup v-model="pop_busi"
                   position="left"
                   closeable
                   aroud
                   close-icon="cross"
                   :style="{
        width: '100%',
        height: '100%',
        background: '#fff',
        'border-radius': '0'
      }">
          <div class="menu">
            <van-icon name="arrow-left"
                      color="#c8c9cc"
                      size="24"
                      style="position:absolute;left:16px; top:16px;"
                      @click="pop_busi=false" />
            <ul>
              <li><router-link to="/energy">清洁能源业务</router-link></li>
              <li><router-link to="/life">品质生活业务</router-link></li>
              <li><router-link to="/intelligent">产业智能业务</router-link></li>
            </ul>
          </div>
        </van-popup>
        <ul>
          <li @click="pop_about = true">
            <router-link to="">关于新奥</router-link>
          </li>
          <li @click="pop_busi = true">
            <router-link to="">业务布局</router-link>
          </li>
          <li>
            <router-link to="/innovate">创新能力</router-link>
          </li>
          <li>
            <router-link to="/talent">人才激发</router-link>
          </li>
          <li>
            <router-link to="/news">新奥动态</router-link>
          </li>
        </ul>
        <div class="sellang">
          <template v-if="langType=='t'">
            <a @click="myTran('s');"
               class="zh_click">简体</a>
            <a class="zh_click on">繁体</a>
          </template>
          <template v-else>
            <a class="zh_click on">简体</a>
            <a @click="myTran('t');"
               class="zh_click">繁体</a>
          </template>
          <router-link to="/En_home">ENG</router-link>
        </div>
      </div>
      <!-- 菜单结束 -->
    </van-popup>
    <!-- 顶部导航 -->
    <div class="topperbar">
      <router-link to="/"><img src="../assets/logo.png"
             class="logo"></router-link>
      <!-- <img src="../assets/search_icon.png" alt="" class="search_icon"> -->
      <img src="../assets/menu_icon.png"
           alt=""
           @click="popUpMenu"
           class="menu_icon">
    </div>
  </div>
</template>

<script>
import scrollReveal from "scrollreveal";
export default {
  name: "Topper",
  data () {
    return {
      scrollReveal: scrollReveal(),
      pop_about: false,
      pop_busi: false,
      popmenu: false,
      langType: 's'
    };

  },
  methods: {
    goToPage (url, maodian) {
      console.log(window.location.hash)
      console.log(url)
      let nowUrl = window.location.hash.replace('#/', '')
      if (nowUrl !== url) {
        this.$router.push({ name: url, params: { maodian: maodian } })
      } else {
        this.popmenu = false
        this.pop_about = false
        this.pop_busi = false
        const targetElement = document.querySelector(maodian);
        window.scrollTo({ top: targetElement.offsetTop - 45, behavior: 'smooth' });
      }
    },
    popUpMenu () {
      this.popmenu = true;
      this.init();
    },
    init () {
      if (localStorage.getItem("typeface") && localStorage.getItem("typeface") === "繁体") {
        this.langType = "t";
        // eslint-disable-next-line no-undef
        zh_tran("t");
        this.$nextTick(() => {
          this.langType = "t";
          // eslint-disable-next-line no-undef
          zh_tran("t");
        })
      } else {
        this.langType = "s";
        // eslint-disable-next-line no-undef
        zh_tran("s");
        this.$nextTick(() => {
          this.langType = "s";
          // eslint-disable-next-line no-undef
          zh_tran("s");
        })
      }
    },
    myTran (langType) {
      localStorage.setItem("typeface", langType === "t" ? "繁体" : "简体");
      // eslint-disable-next-line no-undef
      zh_tran(langType);
      this.langType = langType;
    }
  },
  mounted () {
    this.scrollReveal.reveal(".reveal-top", {
      // 动画的时长
      duration: 500,
      // 延迟时间
      delay: 0,
      // 动画开始的位置，'bottom', 'left', 'top', 'right'
      origin: "top",
      // 回滚的时候是否再次触发动画
      reset: true,
      // 在移动端是否使用动画
      mobile: true,
      // 滚动的距离，单位可以用%，rem等
      distance: "1rem",
      // 其他可用的动画效果
      opacity: 0.2,
      //速度 easing: ‘cubic-bezier(0.5, 0, 0, 1)’
      easing: "linear"
      //旋转
      // rotate: { x: 180, y: 180, z: 60 },
      // scale: 1
    });
    this.scrollReveal.reveal(".reveal-bottom", {
      // 动画的时长
      duration: 500,
      // 延迟时间
      delay: 0,
      // 动画开始的位置，'bottom', 'left', 'top', 'right'
      origin: "bottom",
      // 回滚的时候是否再次触发动画
      reset: true,
      // 在移动端是否使用动画
      mobile: true,
      // 滚动的距离，单位可以用%，rem等
      distance: "1rem",
      // 其他可用的动画效果
      opacity: 0.2,
      //速度 easing: ‘cubic-bezier(0.5, 0, 0, 1)’
      easing: "linear"
      //旋转
      // rotate: { x: 180, y: 180, z: 60 },
      // scale: 1
    });
    this.scrollReveal.reveal(".reveal-left", {
      // 动画的时长
      duration: 600,
      // 延迟时间
      delay: 0,
      // 动画开始的位置，'bottom', 'left', 'top', 'right'
      origin: "left",
      // 回滚的时候是否再次触发动画
      reset: true,
      // 在移动端是否使用动画
      mobile: true,
      // 滚动的距离，单位可以用%，rem等
      distance: "1rem",
      // 其他可用的动画效果
      opacity: 0.2,
      //速度 easing: ‘cubic-bezier(0.5, 0, 0, 1)’
      easing: "linear"
      //旋转
      // rotate: { x: 180, y: 180, z: 60 },
      // scale: 1
    });
    this.scrollReveal.reveal(".reveal-right", {
      // 动画的时长
      duration: 600,
      // 延迟时间
      delay: 0,
      // 动画开始的位置，'bottom', 'left', 'top', 'right'
      origin: "right",
      // 回滚的时候是否再次触发动画
      reset: true,
      // 在移动端是否使用动画
      mobile: true,
      // 滚动的距离，单位可以用%，rem等
      distance: "1rem",
      // 其他可用的动画效果
      opacity: 0.2,
      //速度 easing: ‘cubic-bezier(0.5, 0, 0, 1)’
      easing: "linear"
      //旋转
      // rotate: { x: 180, y: 180, z: 60 },
      // scale: 1
    });
    this.scrollReveal.reveal(".reveal-after2", {
      // 延迟时间
      delay: 100,
      distance: "2rem"
    });
    this.scrollReveal.reveal(".reveal-after4", {
      // 延迟时间
      delay: 200,
      distance: "2rem"
    });
    this.init();
  }
};
</script>
<style>
.topper {
  background: #fff;
  width: 750px;
  height: auto;
  overflow: hidden;
}
.topperbar {
  width: 750px;
  height: 95px;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}
.topperbar .logo {
  width: 161px;
  height: 52px;
  float: left;
  margin-left: 32px;
  margin-top: 22px;
}
/* .topperbar .search_icon {
  width:44px;
  height: 44px;
  float: left;
  margin-left:370px;
  margin-top:22px;
} */
.topperbar .menu_icon {
  width: 40px;
  height: 40px;
  float: left;
  margin-left: 470px;
  /* margin-left:50px; */
  margin-top: 25px;
}
/* 弹出菜单 */
.menu {
  width: 80%;
  height: 80%;
  overflow: hidden;
  padding: 10%;
}
.menu ul {
  float: left;
  margin-top: 120px;
  width: 100%;
}
.menu ul li {
  width: 100%;
  height: 100px;
  float: left;
}
.menu li a {
  display: block;
  width: 100%;
  height: 100px;
  line-height: 100px;
  font-size: 32px;
  color: #323233;
}
.sellang {
  width: 80%;
  height: 60px;
  position: absolute;
  bottom: 10%;
}
.sellang a {
  display: block;
  width: 33.33%;
  float: left;
  height: 60px;
  font-size: 36px;
  text-align: center;
  color: #323233;
}
.zh_click.on {
  color: #003f84 !important;
  font-weight: bolder;
}
.zh_click {
  color: #323233 !important;
}
</style>
